// extracted by mini-css-extract-plugin
module.exports = {"section":"layout_section__2cArb","row":"layout_row__2nJbV","column":"layout_column__r4xWe","labelGroup":"layout_labelGroup__1AUbb"};